import clsx from "clsx";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { FCCC } from "@/types";

interface PortalSectionProps {
  /** Translation key for the section label */
  titleKey: string;
  /** Optional control on the opposite side of the title, e.g. "Alle anzeigen" */
  action?: ReactNode;
}

/**
 * One labelled block of portal content: the section heading (plus an optional
 * action next to it) and the content below. Brings no outer margins - the page
 * owns the spacing between its sections.
 */
export const PortalSection: FCCC<PortalSectionProps> = ({
  className,
  titleKey,
  action,
  children,
}) => {
  const { t } = useTranslation("portal");

  return (
    <section className={clsx("flex flex-col gap-4", className)}>
      <div className="flex items-center justify-between gap-4">
        <h2 className="text-headline-sm font-semibold leading-md text-foreground-primary">
          {t(titleKey as any) as string}
        </h2>
        {action}
      </div>
      {children}
    </section>
  );
};
